module.exports = __webpack_public_path__ + "static/media/minus-ico.6ce3be5b.svg";